var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { fontBody } from 'Styles/fonts';
export var StyledSpan = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-decoration: ", ";\n  text-underline-position: under;\n  &:hover {\n    text-underline-position: under;\n    text-decoration: underline;\n  }\n"], ["\n  text-decoration: ", ";\n  text-underline-position: under;\n  &:hover {\n    text-underline-position: under;\n    text-decoration: underline;\n  }\n"])), function (props) { return (props.underline ? 'underline' : 'none'); });
export var StyledIcon = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  ", ";\n"], ["\n  display: inline-block;\n  ", ";\n"])), function (_a) {
    var iconPosition = _a.iconPosition;
    return (iconPosition === 'left' ? 'margin-right: 0.25rem;' : 'margin-left: 0.25rem;');
});
export var StyledLinkContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
export var StyledLink = styled.a(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: inherit;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n  padding: ", ";\n  ", " {\n    ", ";\n\n  }\n\n  ", " {\n    ", "\n  }\n"], ["\n  color: inherit;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n  padding: ", ";\n  ", " {\n    ", ";\n\n  }\n\n  ", " {\n    ", "\n  }\n"])), function (props) {
    if (!props.padding) {
        return '';
    }
    switch (props.size) {
        case 'Mini':
            return '0.44rem 0 0.5rem 0';
        default:
            return '0.5rem 0';
    }
}, StyledSpan, function (props) {
    switch (props.size) {
        case 'Mini':
            return fontBody(14);
        case 'X-Mini':
            return fontBody(12);
        default:
            return fontBody(16);
    }
}, StyledIcon, function (props) {
    switch (props.size) {
        case 'X-Mini':
            return 'margin-left: 0.25rem; font-size: 0.75rem';
        case 'Mini':
            return 'margin-left: 0.25rem; font-size: 0.875';
        case 'Regular':
            return 'margin-left: 0.375rem; font-size: 1rem';
        default:
            return 'margin-left: 0.25rem;';
    }
});
export default {};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
